import AbstractRestApi from './AbstractRestApi'

class BrandsApiClient extends AbstractRestApi {
    getBaseUrl() {
        return '/api/v1/brands'
    }
}

export default new BrandsApiClient()
